import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';

import { formatMatchaFeeRange } from '@/utils/fees';

export function MatchaAutoSwitchOn() {
  return (
    <ul className="w-full mt-2">
      <li className="relative mt-[10px] pb-3 text-token-gray-900 text-350 font-medium border-b border-solid border-token-gray-300 leading-5 tablet:leading-4">
        <CheckmarkIcon className="absolute top-0 mr-[6px] align-middle bottom-[1px] text-token-green-1000" />
        No gas needed
      </li>
      <li className="relative mt-[10px] pb-3 text-token-gray-900 text-350 font-medium border-b border-solid border-token-gray-300 leading-5 tablet:leading-4">
        <CheckmarkIcon className="absolute top-0 mr-[6px] align-middle bottom-[1px] text-token-green-1000" />
        MEV protection
        <span className="text-token-gray-700 before:content-['·'] before:mx-1 before:text-token-gray-1200">
          No slippage
        </span>
      </li>
      <li className="relative mt-[10px] pb-3 text-token-gray-900 text-350 font-medium border-b border-solid border-token-gray-300 leading-5 tablet:leading-4">
        <CheckmarkIcon className="absolute top-0 mr-[6px] align-middle bottom-[1px] text-token-green-1000" />
        130+ liquidity sources
      </li>
      <li className="relative mt-[10px] pb-3 text-token-gray-900 text-350 font-medium border-b border-solid border-token-gray-300 leading-5 tablet:leading-4">
        <CheckmarkIcon className="absolute top-0 mr-[6px] align-middle bottom-[1px] text-token-green-1000" />
        Smart Routing
        <span className="text-token-gray-700 before:content-['·'] before:mx-1 before:text-token-gray-1200">
          Auto
        </span>
      </li>
      <li className="mt-[10px] pb-0 text-token-gray-900 text-350 font-medium leading-5 tablet:leading-4">
        {formatMatchaFeeRange('auto')} fee on certain pairs
      </li>
    </ul>
  );
}
